document.addEventListener('DOMContentLoaded', function () {
  var accordionBoxes = document.querySelectorAll('.product-accordions--box');

  // console.log(accordionBoxes);

  if (accordionBoxes.length > 0) {
    accordionBoxes[0].classList.add('active');

    accordionBoxes.forEach((box) => {
      const title = box.querySelector('.product-accordions--box__title');
      title.addEventListener('click', () => {
        accordionBoxes.forEach((otherBox) => {
          if (otherBox !== box) {
            otherBox.classList.remove('active');
            otherBox.querySelector('.product-accordions--box__desc').style.maxHeight = null;
          }
        });

        const desc = box.querySelector('.product-accordions--box__desc');
        if (box.classList.contains('active')) {
          box.classList.remove('active');
          desc.style.maxHeight = null;
        } else {
          box.classList.add('active');
          desc.style.maxHeight = desc.scrollHeight + 'px';
        }
      });
    });
  }
});
